// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  userId: __t.string().name("user_id"),
  organizationId: __t.string().name("organization_id"),
  companyName: __t.string().name("company_name"),
  billingEmail: __t.string().name("billing_email"),
  addressLine1: __t.string().name("address_line_1"),
  addressLine2: __t.string().name("address_line_2"),
  city: __t.string(),
  state: __t.string(),
  postalCode: __t.string().name("postal_code"),
  certificateKey: __t.string().name("certificate_key"),
  status: __t.string(),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
